import {
  ApplyOrderItemDiscount,
  CreateDiscountForOrderItemRequest,
  CreateDiscountForOrderRequest,
  DeleteItemDiscountRequest,
  DeleteOrderDiscountRequest,
  DeletePromoCodeFromOrderRequest,
  OrdersApi,
  ResponseError,
} from '@trybeapp/sdk'
import { useMutation, useQueryClient } from 'react-query'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new OrdersApi(apiConfiguration)

export const useApplyOrderDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ orderId, applyDiscountToOrder }: CreateDiscountForOrderRequest) => {
      return await api.createDiscountForOrder({
        orderId,
        applyDiscountToOrder,
      })
    },
    {
      onSuccess: (_, { orderId }) => {
        queryClient.invalidateQueries(['orders', orderId])
        queryClient.invalidateQueries(['orderDiscounts', orderId])
      },
    }
  )
}

export const useRemoveOrderDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation<void, ResponseError, DeleteOrderDiscountRequest>(
    ({ orderId, discountId }) => {
      return api.deleteOrderDiscount({
        orderId,
        discountId,
      })
    },
    {
      onSuccess: (_, { orderId }) => {
        queryClient.invalidateQueries(['orders', orderId])
        queryClient.invalidateQueries(['orderDiscounts', orderId])
      },
    }
  )
}

export const useApplyOrderItemDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation<ApplyOrderItemDiscount, ResponseError, CreateDiscountForOrderItemRequest>(
    ({ orderId, itemId, applyDiscountToOrderItem }) => {
      return api.createDiscountForOrderItem({
        orderId,
        itemId,
        applyDiscountToOrderItem,
      })
    },
    {
      onSuccess: (_, { orderId }) => {
        queryClient.invalidateQueries(['orders', orderId])
      },
    }
  )
}

export const useRemoveOrderItemDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation<void, ResponseError, DeleteItemDiscountRequest>(
    async ({ orderId, itemId, discountId }) => {
      return await api.deleteItemDiscount({
        orderId,
        itemId,
        discountId,
      })
    },
    {
      onSuccess: (_, { orderId }) => {
        queryClient.invalidateQueries(['orders', orderId])
      },
    }
  )
}

export const useRemovePromoCode = () => {
  const queryClient = useQueryClient()

  return useMutation<void, ResponseError, DeletePromoCodeFromOrderRequest>(
    ({ orderId, discountTypeId }) => {
      return api.deletePromoCodeFromOrder({
        orderId,
        discountTypeId,
      })
    },
    {
      onSuccess: (_, { orderId, discountTypeId }) => {
        queryClient.invalidateQueries(['orders', orderId])
        queryClient.invalidateQueries(['orderDiscounts', orderId])
        queryClient.invalidateQueries(['discountTypes', discountTypeId])
      },
    }
  )
}
